import {createDcaaRepository} from './dcaa/repo'
import {createOrderService} from './dcaa/service'
import {fetch} from './fetch'

const dcaaRepository = createDcaaRepository({fetch})

export const {fetchAcceptOffer, fetchFormLayout, fetchPollSharing, fetchSafeFlowChallenge} = createOrderService({
  dcaaRepository,
})
